// Avis (refonte 2026), porté de src/sections/reviews.js du prototype : 8 fenêtres glass autour du titre,
// qui suivent un peu le curseur, chacune à sa profondeur (--depth).
// Les avis sont les vrais avis Junip, lus avec la clé publique du widget (celle que l'app pose dans
// chaque page, .junip-store-key[data-store-key]) : on garde les meilleurs (épinglés et mis en avant
// d'abord, puis 4–5 étoiles avec un titre et un texte court).
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine = matchMedia('(hover: hover) and (min-width: 761px)');
const API = 'https://api.juniphq.com/v1';

function storeKey(section) {
  return document.querySelector('.junip-store-key[data-store-key]')?.dataset.storeKey || section.dataset.junipKey || '';
}

async function junip(path, key) {
  const r = await fetch(`${API}/${path}`, { headers: { 'Junip-Store-Key': key } });
  if (!r.ok) throw new Error(`Junip ${r.status}`);
  return r.json();
}

function pick(reviews, n) {
  const score = r => (r.pinned ? 4 : 0) + (r.featured ? 2 : 0) + (r.title && (r.body || '').length <= 140 ? 1 : 0);
  return reviews
    .filter(r => r.rating >= 4 && (r.title || r.body))
    .sort((a, b) => score(b) - score(a) || new Date(b.created_at) - new Date(a.created_at))
    .slice(0, n);
}

const nameOf = c => c ? [c.first_name, c.last_name ? `${c.last_name.trim().charAt(0)}.` : ''].filter(Boolean).join(' ') : '';
const decimal = n => n.toFixed(2).replace('.', ',');

function fill(li, r, starTpl) {
  const stars = li.querySelector('.review__stars');
  stars.setAttribute('aria-label', `${r.rating} étoiles sur 5`);
  stars.replaceChildren(...Array.from({ length: 5 }, (_, i) => {
    const s = starTpl.content.firstElementChild.cloneNode(true);
    if (i >= r.rating) s.classList.add('star--empty');
    return s;
  }));
  li.querySelector('.review__title').textContent = r.title || '';
  li.querySelector('.review__text').textContent = r.body || '';
  li.querySelector('.review__name').textContent = nameOf(r.customer);
  li.querySelector('.review__product').textContent = r.target_title ? `Avis pour ${r.target_title}` : '';
  li.hidden = false;
}

async function load(section) {
  const key = storeKey(section);
  if (!key) return;
  const items = [...section.querySelectorAll('.review')];
  const starTpl = section.querySelector('template[data-star]');
  try {
    const [list, overview] = await Promise.all([
      junip('product_reviews?page%5Bsize%5D=40&include=customer', key),
      junip('product_overviews', key).catch(() => null),
    ]);
    pick(list.product_reviews || [], items.length).forEach((r, i) => fill(items[i], r, starTpl));
    const o = overview?.product_overviews?.[0];
    if (o?.rating_count) {
      section.querySelector('[data-score-average]').textContent = decimal(o.rating_average);
      section.querySelector('[data-score-count]').textContent = `${o.rating_count} avis`;
      section.querySelector('.reviews__score').hidden = false;
    }
  } catch (e) {
    // Junip indisponible : la section garde son titre (et la note calculée côté Shopify si elle existe)
  }
}

function parallax(section) {
  if (reduced) return;
  const items = [...section.querySelectorAll('.review')].map(el => ({ el, depth: parseFloat(el.style.getPropertyValue('--depth')) || .5 }));
  const MAX = 28;                    // px de déplacement pour une profondeur de 1
  let tx = 0, ty = 0, x = 0, y = 0, raf = 0;
  section.addEventListener('pointermove', e => {
    if (!fine.matches) return;
    const r = section.getBoundingClientRect();
    tx = ((e.clientX - r.left) / r.width - .5) * 2;
    ty = ((e.clientY - r.top) / r.height - .5) * 2;
    if (!raf) raf = requestAnimationFrame(tick);
  });
  section.addEventListener('pointerleave', () => { tx = ty = 0; if (!raf) raf = requestAnimationFrame(tick); });
  function tick() {
    x += (tx - x) * .08; y += (ty - y) * .08;
    for (const { el, depth } of items) {
      el.style.setProperty('--px', `${(-x * MAX * depth).toFixed(2)}px`);   // à l'opposé du curseur, comme à travers une vitre
      el.style.setProperty('--py', `${(-y * MAX * depth).toFixed(2)}px`);
    }
    raf = Math.abs(tx - x) + Math.abs(ty - y) > .001 ? requestAnimationFrame(tick) : 0;
  }
}

function init(section) {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';
  parallax(section);
  // les avis ne se chargent qu'à l'approche de la section
  const io = new IntersectionObserver(es => {
    if (es.some(e => e.isIntersecting)) { io.disconnect(); load(section); }
  }, { rootMargin: '600px 0px' });
  io.observe(section);
}

document.querySelectorAll('[data-reviews]').forEach(init);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-reviews]').forEach(init));
